module.exports = ".test1 {\n    background-color: var(--main-bg-color);\n    color: var(--title-font-color);\n}\n"